export enum MaterialCategory {
  None,
  SparePart,
  Vehicle,
  Service,
}

export const saleMovementCategoryOptions = [
  { label: 'Accesorios / Repuestos', value: MaterialCategory.SparePart },
  { label: 'Vehículos', value: MaterialCategory.Vehicle },
  { label: 'Servicio', value: MaterialCategory.Service },
];
